import React from 'react';

export default function AdminFooter() {
    return (
        <div class="dashboard-footer">
        <div class="flex-between flex-wrap gap-16">
            <p class="text-gray-300 text-13 fw-normal"> &copy; Copyright iTrain 2024, All Right Reserverd</p>
        </div>
    </div>
    );
}
